import { XIcon } from '@heroicons/react/outline'
import { FC, ReactNode } from 'react'

import Modal from '../Modal'
import styles from './Dialog.module.scss'

interface IDialogProps {
  isOpen: boolean
  onClose: () => void
  title: string
  message: string | ReactNode
  customButton?: ReactNode
  customButtonEvent?: () => void
  buttonText?: string
  useCancelButton?: boolean
  buttonClassName?: string
  hideCloseIcon?: boolean
  transition?: boolean
}

const Dialog: FC<IDialogProps> = ({
  isOpen,
  onClose,
  title,
  message,
  customButton,
  customButtonEvent,
  buttonText = '확인',
  useCancelButton = false,
  buttonClassName = '',
  hideCloseIcon = false,
  transition = true,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} transition={transition}>
      <div className={`rounded-lg bg-white p-4 lg:p-5 ${styles.AlertDialogWrapper}`}>
        <header className="flex justify-between">
          <h3 className="text-xl font-bold lg:text-2xl">{title}</h3>
          {!hideCloseIcon && (
            <button className="flex h-5 w-5 items-center justify-center" onClick={onClose}>
              <XIcon className="h-auto w-5"></XIcon>
            </button>
          )}
        </header>
        <main>
          <section className="mt-4 box-border">
            <div>
              <div className={`text-sm lg:text-base ${styles.textWordBreak}`}>{message}</div>
            </div>
          </section>
        </main>
        <footer className="mt-4 flex justify-end">
          {!customButton && (
            <>
              {useCancelButton && (
                <button
                  className="mr-3 flex items-center justify-center rounded-md border border-gray-300 px-5 py-3"
                  onClick={onClose}>
                  <span className="font-semibold">취소</span>
                </button>
              )}
              <button
                className={`flex items-center justify-center rounded-md border border-gray-300 px-5 py-3 ${buttonClassName}`}
                onClick={customButtonEvent || onClose}>
                <span className="font-semibold">{buttonText}</span>
              </button>
            </>
          )}
          {customButton}
        </footer>
      </div>
    </Modal>
  )
}

export default Dialog
